<template>
  <iframe :src="webUrl+'/admin/user.need/list'"></iframe>
</template>

<script>
export default {
  name: "user.need.list",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>